import React from 'react';
import { Input } from '../../input/input.js';
function DateFieldBasic(props) {
    const { externalAction, date, enabled, onBlur, onChange, placeholder, readOnly, valid, sensitiveData } = props;
    const formatters = {
        value: { name: 'date' },
    };
    return (React.createElement("div", { className: "c-date-field--basic" },
        React.createElement("div", { className: "c-date-field__container c-date-field__input" },
            React.createElement(Input, { enabled: enabled, externalAction: externalAction, formatters: formatters, onBlur: onBlur, onChange: onChange, placeholder: placeholder, readOnly: readOnly, sensitiveData: sensitiveData, valid: valid, value: date }))));
}
export { DateFieldBasic, };
//# sourceMappingURL=date-field-basic.js.map